import React from 'react';
import '../styles/ZwykList.css';

interface ListItem {
  header: string;
  description: string;
}

interface ZwykListProps {
  items: ListItem[];
}

const ZwykList: React.FC<ZwykListProps> = ({ items}) => {
  return (
    <div className="zwyk-list">
      {items.map((item, index) => (
        <div key={index} className="zwyk-list-item">
          <div className="zwyk-list-pointer" data-aos="fade-up" data-aos-delay={0} />
          <div className="zwyk-list-content" data-aos="fade-up" data-aos-delay={0}>
            <h3 className="zwyk-list-header">{item.header}</h3>
            <p className="zwyk-list-description">{item.description}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ZwykList; 